import {Injectable} from '@angular/core';
import {HttpClient, HttpParams} from '@angular/common/http';
import {SessionStorageService} from './session-storage.service';
import {BaseApiService} from './base-api.service';
import { Observable } from 'rxjs';

export interface ConsultaExternaRequest {
  clienteDocumento: string,
  produto: number,
  fluxoIdentificador: string,
  origem: string,
}

export interface ConsultaExternaResponse {
  fluxo: number,
  mensagem: string
}

@Injectable({
  providedIn: 'root'
})
export class ConsultaExternaService extends BaseApiService{

  constructor(private httpClient: HttpClient, private localStorageService: SessionStorageService) {
    super('whitelabel/fluxo/consulta-externa', localStorageService);
  }

  consultarFluxo(request: ConsultaExternaRequest): Observable<ConsultaExternaResponse> {
    return this.httpClient.post<ConsultaExternaResponse>(this.baseUrl, request);
  }
}
